import { ReactComponent as AcquireTt } from './acquire-tt.svg'
import { ReactComponent as Acquire } from './acquire.svg'
import { ReactComponent as AddToUser } from './add_to_user.svg'
import { ReactComponent as ArchiveTt } from './archive-tt.svg'
import { ReactComponent as Archive } from './archive.svg'
import { ReactComponent as Arrow } from './arrow.svg'
import { ReactComponent as Arrowpair } from './arrowpair.svg'
import { ReactComponent as AutomationTt } from './automation-tt.svg'
import { ReactComponent as Automation } from './automation.svg'
import { ReactComponent as CalendarTt } from './calendar-tt.svg'
import { ReactComponent as Calendar } from './calendar.svg'
import { ReactComponent as CampaignTt } from './campaign-tt.svg'
import { ReactComponent as Campaign } from './campaign.svg'
import { ReactComponent as CartTt } from './cart-tt.svg'
import { ReactComponent as Cart } from './cart.svg'
import { ReactComponent as CautionHollow } from './caution-hollow.svg'
import { ReactComponent as Caution } from './caution.svg'
import { ReactComponent as CelebrateTt } from './celebrate-tt.svg'
import { ReactComponent as Celebrate } from './celebrate.svg'
import { ReactComponent as Check } from './check.svg'
import { ReactComponent as Checkmark } from './checkmark.svg'
import { ReactComponent as Close } from './close.svg'
import { ReactComponent as ContactTt } from './contact-tt.svg'
import { ReactComponent as Contact } from './contact.svg'
import { ReactComponent as CreateUser } from './create_user.svg'
import { ReactComponent as CriticalHollow } from './critical-hollow.svg'
import { ReactComponent as Critical } from './critical.svg'
import { ReactComponent as CsvTt } from './csv-tt.svg'
import { ReactComponent as Csv } from './csv.svg'
import { ReactComponent as DeliveredTt } from './delivered-tt.svg'
import { ReactComponent as Delivered } from './delivered.svg'
import { ReactComponent as DownloadTt } from './download-tt.svg'
import { ReactComponent as Download } from './download.svg'
import { ReactComponent as DownloadBox } from './download_box.svg'
import { ReactComponent as EditTt } from './edit-tt.svg'
import { ReactComponent as Edit } from './edit.svg'
import { ReactComponent as Exclude } from './exclude.svg'
import { ReactComponent as Expand } from './expand.svg'
import { ReactComponent as FilterTt } from './filter-tt.svg'
import { ReactComponent as Filter } from './filter.svg'
import { ReactComponent as FlowTt } from './flow-tt.svg'
import { ReactComponent as Flow } from './flow.svg'
import { ReactComponent as Gorilla } from './gorilla.svg'
import { ReactComponent as HealthcareTt } from './healthcare-tt.svg'
import { ReactComponent as Healthcare } from './healthcare.svg'
import { ReactComponent as HelpTt } from './help-tt.svg'
import { ReactComponent as Help } from './help.svg'
import { ReactComponent as Hidden } from './hidden.svg'
import { ReactComponent as History } from './history.svg'
import { ReactComponent as HistroyTt } from './histroy-tt.svg'
import { ReactComponent as HomeTt } from './home-tt.svg'
import { ReactComponent as Home } from './home.svg'
import { ReactComponent as Include } from './include.svg'
import { ReactComponent as InfoHollow } from './info-hollow.svg'
import { ReactComponent as Info } from './info.svg'
import { ReactComponent as IntegrationTt } from './integration-tt.svg'
import { ReactComponent as Integration } from './integration.svg'
import { ReactComponent as LeaderboardTt } from './leaderboard-tt.svg'
import { ReactComponent as Leaderboard } from './leaderboard.svg'
import { ReactComponent as LearnTt } from './learn-tt.svg'
import { ReactComponent as Learn } from './learn.svg'
import { ReactComponent as LifeInsuranceTt } from './life-insurance-tt.svg'
import { ReactComponent as LifeInsurance } from './life-insurance.svg'
import { ReactComponent as ListTt } from './list-tt.svg'
import { ReactComponent as List } from './list.svg'
import { ReactComponent as LogoutTt } from './logout-tt.svg'
import { ReactComponent as Logout } from './logout.svg'
import { ReactComponent as MapTt } from './map-tt.svg'
import { ReactComponent as Map } from './map.svg'
import { ReactComponent as MarketplaceTt } from './marketplace-tt.svg'
import { ReactComponent as Marketplace } from './marketplace.svg'
import { ReactComponent as MenuTt } from './menu-tt.svg'
import { ReactComponent as Menu } from './menu.svg'
import { ReactComponent as MetricsTt } from './metrics-tt.svg'
import { ReactComponent as Metrics } from './metrics.svg'
import { ReactComponent as Minimize } from './minimize.svg'
import { ReactComponent as NotifcationActive } from './notifcation-active.svg'
import { ReactComponent as Notification } from './notification.svg'
import { ReactComponent as OutreachTt } from './outreach-tt.svg'
import { ReactComponent as Outreach } from './outreach.svg'
import { ReactComponent as PauseHollow } from './pause-hollow.svg'
import { ReactComponent as Pause } from './pause.svg'
import { ReactComponent as PhoneInbound } from './phone-inbound.svg'
import { ReactComponent as PhoneTt } from './phone-tt.svg'
import { ReactComponent as Phone } from './phone.svg'
import { ReactComponent as PlatformTt } from './platform-tt.svg'
import { ReactComponent as Platform } from './platform.svg'
import { ReactComponent as PlayHollow } from './play-hollow.svg'
import { ReactComponent as Play } from './play.svg'
import { ReactComponent as PreFilterTt } from './pre-filter-tt.svg'
import { ReactComponent as PreFilter } from './pre-filter.svg'
import { ReactComponent as PriceTt } from './price-tt.svg'
import { ReactComponent as Price } from './price.svg'
import { ReactComponent as PrintTt } from './print-tt.svg'
import { ReactComponent as Print } from './print.svg'
import { ReactComponent as SearchTt } from './search-tt.svg'
import { ReactComponent as Search } from './search.svg'
import { ReactComponent as SellTt } from './sell-tt.svg'
import { ReactComponent as Sell } from './sell.svg'
import { ReactComponent as SettingsTt } from './settings-tt.svg'
import { ReactComponent as Settings } from './settings.svg'
import { ReactComponent as SolarTt } from './solar-tt.svg'
import { ReactComponent as Solar } from './solar.svg'
import { ReactComponent as Spinner } from './spinner.svg'
import { ReactComponent as StatusDot } from './status-dot.svg'
import { ReactComponent as SuccessHollow } from './success-hollow.svg'
import { ReactComponent as SuccessTt } from './success-tt.svg'
import { ReactComponent as Success } from './success.svg'
import { ReactComponent as SupportTt } from './support-tt.svg'
import { ReactComponent as Support } from './support.svg'
import { ReactComponent as TcpaTt } from './tcpa-tt.svg'
import { ReactComponent as Tcpa } from './tcpa.svg'
import { ReactComponent as TeamsDropdownDown } from './teams-dropdown-down.svg'
import { ReactComponent as TeamsDropdownUp } from './teams-dropdown-up.svg'
import { ReactComponent as TeamsTt } from './teams-tt.svg'
import { ReactComponent as Teams } from './teams.svg'
import { ReactComponent as ToolsTt } from './tools-tt.svg'
import { ReactComponent as Tools } from './tools.svg'
import { ReactComponent as Trash } from './trash.svg'
import { ReactComponent as UserTt } from './user-tt.svg'
import { ReactComponent as User } from './user.svg'
import { ReactComponent as UsersTt } from './users-tt.svg'
import { ReactComponent as Users } from './users.svg'
import { ReactComponent as Visible } from './visible.svg'
import { ReactComponent as Admin } from './admin.svg'
import { ReactComponent as Action } from './action.svg'

export default {
  'acquire-tt': AcquireTt,
  acquire: Acquire,
  action: Action,
  add_to_user: AddToUser,
  admin: Admin,
  'archive-tt': ArchiveTt,
  archive: Archive,
  arrow: Arrow,
  arrowpair: Arrowpair,
  'automation-tt': AutomationTt,
  automation: Automation,
  'calendar-tt': CalendarTt,
  calendar: Calendar,
  'campaign-tt': CampaignTt,
  campaign: Campaign,
  'cart-tt': CartTt,
  cart: Cart,
  'caution-hollow': CautionHollow,
  caution: Caution,
  'celebrate-tt': CelebrateTt,
  celebrate: Celebrate,
  check: Check,
  checkmark: Checkmark,
  close: Close,
  'contact-tt': ContactTt,
  contact: Contact,
  create_user: CreateUser,
  'critical-hollow': CriticalHollow,
  critical: Critical,
  'csv-tt': CsvTt,
  csv: Csv,
  'delivered-tt': DeliveredTt,
  delivered: Delivered,
  'download-tt': DownloadTt,
  download: Download,
  download_box: DownloadBox,
  'edit-tt': EditTt,
  edit: Edit,
  exclude: Exclude,
  expand: Expand,
  'filter-tt': FilterTt,
  filter: Filter,
  'flow-tt': FlowTt,
  flow: Flow,
  gorilla: Gorilla,
  'healthcare-tt': HealthcareTt,
  healthcare: Healthcare,
  'help-tt': HelpTt,
  help: Help,
  hidden: Hidden,
  history: History,
  'histroy-tt': HistroyTt,
  'home-tt': HomeTt,
  home: Home,
  include: Include,
  'info-hollow': InfoHollow,
  info: Info,
  'integration-tt': IntegrationTt,
  integration: Integration,
  'leaderboard-tt': LeaderboardTt,
  leaderboard: Leaderboard,
  'learn-tt': LearnTt,
  learn: Learn,
  'life-insurance-tt': LifeInsuranceTt,
  'life-insurance': LifeInsurance,
  'list-tt': ListTt,
  list: List,
  'logout-tt': LogoutTt,
  logout: Logout,
  'map-tt': MapTt,
  map: Map,
  'marketplace-tt': MarketplaceTt,
  marketplace: Marketplace,
  'menu-tt': MenuTt,
  menu: Menu,
  'metrics-tt': MetricsTt,
  metrics: Metrics,
  minimize: Minimize,
  'notifcation-active': NotifcationActive,
  notification: Notification,
  'outreach-tt': OutreachTt,
  outreach: Outreach,
  'pause-hollow': PauseHollow,
  pause: Pause,
  'phone-inbound': PhoneInbound,
  'phone-tt': PhoneTt,
  phone: Phone,
  'platform-tt': PlatformTt,
  platform: Platform,
  'play-hollow': PlayHollow,
  play: Play,
  'pre-filter-tt': PreFilterTt,
  'pre-filter': PreFilter,
  'price-tt': PriceTt,
  price: Price,
  'print-tt': PrintTt,
  print: Print,
  'search-tt': SearchTt,
  search: Search,
  'sell-tt': SellTt,
  sell: Sell,
  'settings-tt': SettingsTt,
  settings: Settings,
  'solar-tt': SolarTt,
  solar: Solar,
  spinner: Spinner,
  'status-dot': StatusDot,
  'success-hollow': SuccessHollow,
  'success-tt': SuccessTt,
  success: Success,
  'support-tt': SupportTt,
  support: Support,
  'tcpa-tt': TcpaTt,
  tcpa: Tcpa,
  'teams-dropdown-down': TeamsDropdownDown,
  'teams-dropdown-up': TeamsDropdownUp,
  'teams-tt': TeamsTt,
  teams: Teams,
  'tools-tt': ToolsTt,
  tools: Tools,
  trash: Trash,
  'user-tt': UserTt,
  user: User,
  'users-tt': UsersTt,
  users: Users,
  visible: Visible
} as const
